import CycleStatus from '../../../enums/cycle-status.enum';

export const STATIC_CHART_DATA_TYPE = 'STATIC' as const;
export const LIVE_CHART_DATA_TYPE = 'LIVE' as const;

export const TAB_NUMBER = {
  [STATIC_CHART_DATA_TYPE]: 0,
  [LIVE_CHART_DATA_TYPE]: 1,
};

export const TAB_NUMBER_TO_TYPE = {
  0: STATIC_CHART_DATA_TYPE,
  1: LIVE_CHART_DATA_TYPE,
};

export const NO_TAB_SELECTED = -1;

export const CYCLE_STATUS_TO_TAB_NUMBER: Record<CycleStatus, number> = {
  [CycleStatus.InActive]: NO_TAB_SELECTED,
  [CycleStatus.Completed]: 0,
  [CycleStatus.Active]: 1,
};
